
import { defineComponent } from "vue";
import ModalListInput from "@/components/Common/ModalListInput.vue";

export default defineComponent({
  props: { value: Array, type: String },
  components: { ModalListInput },
});
